import { Box } from "@mui/material";
import React from "react";
import { IStaticAccordion, IStaticGroup, IStaticGroupItem, IStaticSubGroupItem } from "../../../../Contracts/StaticDataAccordion";
import { MDTypography } from "../MDTypography";

interface IProps extends IStaticAccordion{
  followLink: (link: string | undefined, number: number | undefined) => void;
}
export const StaticDataAccordion = (props: IProps) => {

  const displayStaticGroupHeadingLink = (item: IStaticGroupItem): React.ReactNode => {
    if(item.link != null){
      return (
      <button
       style={{ background: 'none', cursor: 'pointer', border: 'none', color:'#097384'}}
        onClick={() => props.followLink(item.link, item.section)}>{item.title}
      </button>
      );
    }
    return (
      <p style={{margin: 0}}>{item.title}</p>
    );
   
  }
  return (
    <div className="panel panel-default">
      <Box> 
        <MDTypography style={{ padding:'10px',fontSize: '16px', background: '#4d4f53', color: 'white', marginBottom: "5px"}}>
          {props.title}
        </MDTypography>
      </Box>
      {props.groups.map((groupItem: IStaticGroup, index: any) => {
        return (
          <Box key={index} >
            {groupItem.title != null && 
            <MDTypography margin={2} component='span' variant='body' fontSize='0.95rem' fontWeight='regular' >
             {groupItem.title}</MDTypography>}
            <MDTypography component='span' variant='body' fontSize='0.87rem' fontWeight='regular' >
              <ul style={{paddingLeft: '30px', marginTop: '10px'}}>
                {groupItem.items.map((item: IStaticGroupItem, index: any) => {
                  return (
                    <Box key={index}>
                      <li key={index} style={{margin:'3px',  marginTop:'3px'}}>
                        {displayStaticGroupHeadingLink(item)}
                      </li>
                      {item.subItem?.map((sub: IStaticSubGroupItem, index: any) => {
                        return (
                          <ul style={{paddingLeft: '25px', marginTop: '5px'}} key={index}>
                            <li key={index} style={{ margin:'3px',  marginTop:'3px'}}>
                              {displayStaticGroupHeadingLink(sub)}
                            </li>
                          </ul>
                        );
                      })}
                    </Box>
                  );
                })}
              </ul>
            </MDTypography>
          </Box>
        );
      })}
    </div>
  );
};
